// extracted by mini-css-extract-plugin
export default {"title":"V_-z","warning":"W_-z","sizeOptionsLegendText":"X_-z"};